import React from 'react'
import { currencyFullValue, percentageFormat } from '../../core/helpers'

import Card from '../Card/Card'
import List from '../List/List'
import events from '../../core/EventEmitter'
import ModalTvlChart from '../Modal/ModalTvlChart'
import { Candles } from '../Icon'
import ModalVolumeChart from '../Modal/ModalVolumeChart'

function CoinVolume({ volumes, coinId, launchDate }) {

  const mCapTvlRatio = (volumes.marketCap && volumes.tvl) ? volumes.marketCap / volumes.tvl : 0
  const onClickTvl = () => {
    if (volumes.tvl) {
      events.showModal(<ModalTvlChart coinId={coinId} />, "TVL Chart")
    }
  }

  const onClickVolume = () => {
    events.showModal(<ModalVolumeChart coinId={coinId} />, "Chart (24h)")
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div>
        <Card className="h-full">
          <List>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">Market Cap</div>
              <span className="text-oz">{currencyFullValue(volumes.marketCap)}</span>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">In Circulation</div>
              <div className="text-oz">
                {currencyFullValue(volumes.circulatingSupply, { thousandSeparated: true, mantissa: 0 })}
              </div>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">Total Supply</div>
              <div className="text-oz">{currencyFullValue(volumes.totalSupply)}</div>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">Diluted MCap</div>
              <div className="text-oz">{currencyFullValue(volumes.dilutedValuation)}</div>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">Launch Date</div>
              <div className="text-oz">{launchDate || <span className="text-grey-50">N/A</span> }</div>
            </li>
          </List>
        </Card>
      </div>

      <div>
        <Card className="h-full">
          <List>
            <li className="list-group-item flex justify-between py-3 cursor-pointer hover:bg-white/5 transition-colors" style={{ backgroundColor: 'transparent' }} onClick={onClickVolume}>
              <div className="text-grey">Trading Volume</div>
              <div className="text-oz flex items-center">
                {currencyFullValue(volumes.totalVolume)}
                {volumes.totalVolume && <Candles className="ml-1" />}
              </div>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">Volume Rank</div>
              <span className="text-grey-50">N/A</span>
            </li>
            <li className="list-group-item flex justify-between py-3 cursor-pointer hover:bg-white/5 transition-colors" style={{ backgroundColor: 'transparent' }} onClick={onClickTvl}>
              <div className="text-grey">Total Value Locked</div>
              <div className="text-oz flex items-center">
                {currencyFullValue(volumes.tvl)}
                {volumes.tvl && <Candles className="ml-1" />}
              </div>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">TVL Rank</div>
              <div className="text-grey-50">N/A</div>
            </li>
            <li className="list-group-item flex justify-between py-3" style={{ backgroundColor: 'transparent' }}>
              <div className="text-grey">M.cap / TVL ratio</div>
              <div className="text-oz">
                {percentageFormat(mCapTvlRatio, { forceSign: false }, <span className="text-grey-50">N/A</span>)}
              </div>
            </li>
          </List>
        </Card>
      </div>
    </div>
  )
}

export default CoinVolume
